type UserRole = {
  value: Role;
  label: string;
};

// This list must match `userRoles` in etc/switchboard/common/permissions-config.yaml, which is
// where the backend reads them from. A role added there and not here is skipped by `isRole` below.
const UserRoles: Record<Role, UserRole> = {
  operator: {
    value: "operator",
    label: "Operator",
  },
  viewer: {
    value: "viewer",
    label: "Viewer",
  },
  developer: {
    value: "developer",
    label: "Developer",
  },
  tester: {
    value: "tester",
    label: "Tester",
  },
  cs: {
    value: "cs",
    label: "CS",
  },
  beta_backfill: {
    value: "beta_backfill",
    label: "Beta Backfill",
  },
} as const;

export type Role = "operator" | "viewer" | "developer" | "tester" | "cs" | "beta_backfill";

// Roles arrive from the backend as plain strings; narrowing here avoids asserting them.
export const isRole = (value: string): value is Role => value in UserRoles;

export default UserRoles;
